import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { RpcRoute } from '@core-layout/app/models/rpc-route';
import { RouteService } from '@core-layout/app/services/route.service';
import { SettingsStoreService } from '@settings/store/services/settings-store.service';
import { PROFILE_TABS_NAMES } from 'app/modules/user-modules/profile-modules/profile-base/constants/profile-tabs.constants';
import { ProfileBaseStoreService } from '../../profile-modules/profile-base/store/services/profile-base-store.service';

export const additionalProfileGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const routeService = inject(RouteService);
    const profileBaseStoreService = inject(ProfileBaseStoreService);

    return inject(SettingsStoreService).getSettings().pipe(
        take(1),
        switchMap(settings => {
            const canSeeAdditionalProfilePage = settings?.permissionSettings?.allowMultipleProfiles ?? false;

            if (!canSeeAdditionalProfilePage || route.params.id == null) {
                routeService.navigate(RpcRoute.Profile, { state: { tab: PROFILE_TABS_NAMES.GENERAL } }).catch(() => { });

                return of(false);
            }

            profileBaseStoreService.setActiveAdditionalProfileId(+route.params.id);

            return of(true);
        })
    );
}; 